<template>
  <div class="emailExclude">
    <div class="search">
     <el-row>
      <el-col :span="12">
        <div class="emailNum">
          手动排除发送列表
        </div>
      </el-col>
      <el-col :span="12" class="SearchRight">
        <el-button size="mini" type="primary"  @click="addEmailDialogVisible=true">添加</el-button>
        <el-button size="mini" plain class="SearchBtn" :disabled="multipleSelection.length==0" @click="delEmail">删除</el-button>
        <el-input v-model="email" placeholder="请输入要搜索的邮箱" prefix-icon="el-icon-search" size="small" @keydown.enter.native="searchData" clearable></el-input>
      </el-col>
     </el-row>
    </div>
    <div class="tableList">
      <el-table
      class="fine-scroll-bar"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @sort-change="sortchange"
        :height="$store.state.userInfo.loginAsManagerId>0?'calc(100vh - 290px)':'calc(100vh - 245px)'"
        v-loading="loading"
        >
        <template slot="empty">
          <div class="emptycontent">
            <div class="emptycontentDiv">
              <div class="emptycontentimg">
                <img src="@/assets/image/common/mailnoData.png" alt="">
              </div>
              <div class="emptyText">
                暂无数据
              </div>
            </div>
          </div>
        </template>
        <el-table-column
          type="selection"
          align="center"
          width="65">
        </el-table-column>
        <!-- 类型 -->
        <el-table-column
          prop="name"
          label="类型"
        >
        <template>
          <div>
            排除发送
          </div>
        </template>
        </el-table-column>
        <!-- 生成日期 -->
        <el-table-column
          prop="email"
          label="生成日期"
          >
          <template slot-scope="scope">
            <div>
              {{scope.row.createTime | format('YYYY-MM-DD HH:mm:ss')}}
            </div>
          </template>
        </el-table-column>
        <!-- 收件人邮箱 -->
        <el-table-column
          prop="address"
          label="收件人邮箱"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{scope.row.email | noText}}
            </span>
          </template>
        </el-table-column>
        <!-- 排除发送说明 -->
        <el-table-column
          prop="remark"
          label="排除发送说明"
          show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span >
              {{scope.row.remark | noText}}
            </span>
          </template>
        </el-table-column>
        <!-- 发件人邮箱 -->
        <el-table-column
          prop="sendMail"
          label="发件人邮箱"
          show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span >
              {{scope.row.sendMail | noText}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagetionStyle"> 
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes,prev,pager,next, jumper"
          :total="totalNum"
          ref="pagina"
          >
        </el-pagination>
      </div>
    </div>
    <div>
      <el-dialog
        title="增加邮箱"
        :visible.sync="addEmailDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
        >
        <el-form :model="form" :rules="rulse" ref="formEmail">
          <el-form-item :label="'类型'" label-width="100px" >
              <div>
                排除发送
              </div>
          </el-form-item>
          <el-form-item :label="'发件人邮箱'" label-width="100px">
            <div>{{sendEmail}}</div>
          </el-form-item>
          <el-form-item :label="'收件人邮箱'" label-width="100px" prop="email">
            <el-input placeholder="请输入" v-model.trim="form.email"></el-input>
          </el-form-item>
          <el-form-item :label="'排除发送说明'" label-width="100px">
            <el-input placeholder="请输入" type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button v-no-more-click type="primary" @click="addEmail">确 认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {queryExcludePage,delExcludeEmail,addExcludeEmail} from "@/utils/api/edmSubject"
export default {
  props:{
    sendEmail:{
      type:String,
      default:''
    }
  },
  data(){
      // 邮箱校验
    var checkEmail = (rule, value, callback) => {
      const reg =
        /^([a-zA-Z0-9_\-.]+)@(([a-zA-Z0-9-]+\.)+)([a-zA-Z]{2,10}|[0-9]{1,3})$/;
      if (value === "" || !value) {
        return callback(new Error('输入邮箱'));
      }
      else if (!reg.test(value)) {
        return callback(new Error('邮箱格式有误'));
      } else {
        callback();
      }
    };
    return{
      totalNum:0,
      pageSize:10,
      curPage:1,
      tableData: [],
      multipleSelection: [],
      email:'',
      multipleSelectionId:[],
      addEmailDialogVisible:false,
      form:{
        email:'',//收件人邮箱
        remark:'',//排除发送说明
      },
      rulse:{
        email:[{ required: false, validator: checkEmail, trigger: "blur" },]
      },
      loading:false
    }
  },
  mounted(){
    if(this.$route.query.email){
      this.email=this.$route.query.email
    }
    this.getqueryExcludePage()
  },
  methods:{
    // 翻页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize=val
      this.handleCurrentChange(1)
    },
    // 当前页
    handleCurrentChange(val) {
      this.curPage=val
      this.getqueryExcludePage()
    },
    // 表格选中
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
      this.multipleSelectionId=[]
      this.multipleSelection.map(item=>{
        this.multipleSelectionId.push(item.id)
      })
    },
    // 排序 
    sortchange({ column, prop, order }){
      console.log({ column, prop, order })
    },
    // 获取数据
    async getqueryExcludePage(){
      this.loading=true
      const prams={
        pageSize:this.pageSize,
        curPage:this.curPage,
        email:this.email,
        attribute:'',
        sortType:''
      }
      const res =await queryExcludePage(prams)
      console.log(res)
      this.tableData=res.rspPageData.list
      this.totalNum=res.rspPageData.totalNum
      this.loading=false
    },
    // 批量删除
    async delEmail(){
      const parms={
        ids:this.multipleSelectionId
      }
      const res=await delExcludeEmail(parms)
      this.handleSizeChange(10)
    },
    // 批量添加
    async addEmail(){
       new Promise((resolve, reject) => {
        this.$refs["formEmail"].validate(valid => {
          resolve(valid)
        }).catch((err) => {
          reject(err);
        })
      }).then((resolve)=>{
        if(resolve){
          addExcludeEmail(this.form)
          setTimeout(()=>{
            this.handleClose()
            this.handleSizeChange(10)
          },1000)
        }

      })
      
    },
    handleClose(){
      this.addEmailDialogVisible = false
      this.form.email=''
      this.form.remark=''
    },
    async searchData(e){
      if(e.keyCode==13){
        this.handleSizeChange(10)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pagetionStyle{
  text-align: center;
  margin-top: 20px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
.divBtn{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #066EB7;
  cursor: pointer;
}
.emailExclude{
  // padding-left: 24px;
  // margin-top: 40px;
}
::v-deep .search{
    padding: 8px 20px;
    background: #F5F7FA;
    line-height: 36px;
  .emailNum{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #16181A;
  }
  .SearchRight{
    display: flex;
    .SearchBtn{
      margin-right: 12px;
    }
  }
  .el-input--small .el-input__inner{
    border: none;
  }
}
.tableList{
  padding: 20px;
  .emptycontent{
    min-height: 280px;
    .emptycontentDiv{
      // margin-top: calc(518 / 1200 * 100%);
      .emptycontentimg{
        width: 300px;
        height: 180px;
        // background: gray;
        margin: 0 auto;
        // margin-top: 200px;
        img{
          width: 100%;
          height: 100%;
        }
        // margin-bottom: 200px;
      }
      .emptyText{
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #4F5D78;
        line-height: 20px;
        // margin-bottom: 200px;
      }
    }

  }
}

::v-deep .fine-scroll-bar {
    .el-table__body-wrapper{
    scrollbar-width: thin !important;//滚动条变细，为none时隐藏滚动条
    // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }
}
</style>